import axios from "axios";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import { useContext, useEffect, useState } from "react";
import imgGraph from "../../assets/bg-17bolinhas.webp";
import imgGraph2 from "../../assets/bg-19bolinhas.webp";
import logoAbrafati from "../../assets/logo-abrafati.png";
import CardPopUp from "../../components/cardPopUp/cardPopUp";
import CardRelatorio from "../../components/cardRelatorio/cardRelatorio";
import Loading from "../../components/loading/loading";
import { AuthContext } from "../../contexts/auth";
import "./_relatorio.scss";

HighchartsMore(Highcharts);

function Relatorio() {
    const { updateToken, cyrcleStorage } = useContext(AuthContext);
    const ciclysAkatu = JSON.parse(localStorage.getItem("@ciclysAkatu"));
    const nameUser = JSON.parse(localStorage.getItem("@user"))?.company_data
        ?.company;

    const [showPopUp, setShowPopUp] = useState(false);
    const [options, setOptions] = useState({});
    const [data, setData] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showSectorData, setShowSectorData] = useState(false);
    const [showBenchmarkData, setShowBenchmarkData] = useState(false);
    const [showBenchmarkInMandala, setShowBenchmarkInMandala] = useState(false);
    const [companyRoleId, setCompanyRoleId] = useState(null);

    const THEME_QUADRANT_ORDER = [
        "Capital Social",
        "Meio Ambiente",
        "Capital Humano",
        "Governança e Liderança",
    ];

    useEffect(() => {
        setIsLoading(true);

        const headers = {
            Authorization: `Bearer ${localStorage.getItem("@token")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
        };

        const fetchPesquisa = axios.get(
            `${process.env.REACT_APP_API_URL}/pesquisa/${cyrcleStorage}`,
            { headers },
        );
        const fetchRelatorio = axios.get(
            `${process.env.REACT_APP_API_URL}/pesquisa/${cyrcleStorage}/relatorio`,
            { headers },
        );

        Promise.all([fetchPesquisa, fetchRelatorio])
            .then(([pesquisaRes, relatorioRes]) => {
                const showSector = !!pesquisaRes?.data?.data?.show_sector_data;
                const showBenchmark =
                    !!pesquisaRes?.data?.data?.show_benchmark_data;
                const showMandala =
                    !!pesquisaRes?.data?.data?.show_benchmark_in_mandala;
                const roleId = pesquisaRes?.data?.data?.company_role_id;

                setShowSectorData(showSector);
                setShowBenchmarkData(showBenchmark);
                setShowBenchmarkInMandala(showMandala);
                setCompanyRoleId(roleId);

                const themes = pesquisaRes?.data?.data?.themes || [];
                const relatorioSubthemes =
                    relatorioRes?.data?.data?.subthemes || [];

                const orderedSubthemes = buildChartData(
                    themes,
                    relatorioSubthemes,
                );

                setOptions(setOptionsChart(orderedSubthemes, showMandala));
                setData(relatorioRes);
                setIsLoading(false);
                setShowPopUp(false);
            })
            .catch(() => {
                setIsLoading(false);
                setShowPopUp(true);
                setData(false);
            });
    }, [cyrcleStorage]);

    useEffect(() => {
        document.title = "Abrafati - Relatório";
        window.scroll({ top: 0 });
        updateToken();
    }, []);

    useEffect(() => {
        const handleBeforePrint = () => {
            Highcharts.charts.forEach((chart) => {
                if (chart) {
                    chart.reflow();
                }
            });
        };

        window.addEventListener("beforeprint", handleBeforePrint);
        return () =>
            window.removeEventListener("beforeprint", handleBeforePrint);
    }, []);

    function buildChartData(themes, relatorioSubthemes) {
        const relatorioMap = {};
        relatorioSubthemes.forEach((s) => {
            relatorioMap[s.id] = s;
        });

        const sortedThemes = THEME_QUADRANT_ORDER.map((name) =>
            themes.find((t) => t.title === name),
        ).filter(Boolean);

        const orderedSubthemes = [];

        sortedThemes.forEach((theme) => {
            theme.subthemes.forEach((sub) => {
                const relSub = relatorioMap[sub.id];
                if (relSub) {
                    orderedSubthemes.push(relSub);
                }
            });
        });

        return orderedSubthemes;
    }

    function setOptionsChart(subthemes, showMandala) {
        let array = [];
        let benchmark = [];

        subthemes?.forEach((subtheme) => {
            array.push({ y: subtheme.value, color: subtheme.color });
            benchmark.push({ y: subtheme.benchmark, color: subtheme.color });
        });

        return {
            chart: {
                polar: true,
                backgroundColor: "transparent",
                spacing: [30, 30, 30, 30],
            },
            title: {
                text: null,
            },
            pane: {
                startAngle: 0,
                endAngle: 360,
                size: "65%",
            },
            tooltip: {
                style: {
                    fontSize: "16px",
                },
                formatter: function () {
                    return (
                        subthemes[this.point.index]?.stage?.description ||
                        this.y
                    );
                },
            },
            xAxis: {
                type: "category",
                categories: subthemes?.map((s) => s.title) || [],
                tickmarkPlacement: "on",
                lineWidth: 0,
                labels: {
                    enabled: true,
                    distance: 45,
                    style: {
                        whiteSpace: "normal",
                        width: "120px",
                        fontSize: "12px",
                        textAlign: "center",
                    },
                },
            },
            yAxis: {
                min: 0,
                max: 5,
                tickInterval: 1,
                gridLineInterpolation: "circle",
                labels: {
                    enabled: false,
                },
            },
            plotOptions: {
                series: {
                    pointPlacement: "on",
                },
            },
            series: [
                {
                    type: "column",
                    name: "Resultado",
                    data: array,
                    zIndex: 2,
                    pointPadding: 0,
                    groupPadding: 0,
                    opacity: 0.85,
                },
                ...(showMandala
                    ? [
                          {
                              type: "line",
                              name: "Referência",
                              data: benchmark,
                              zIndex: 3,
                              enableMouseTracking: false,
                              dashStyle: "2, 3",
                              lineWidth: 1,
                              color: "#999",
                              marker: {
                                  enabled: true,
                                  radius: 4,
                                  lineWidth: 1,
                                  lineColor: "#fff",
                              },
                          },
                      ]
                    : []),
                {
                    type: "scatter",
                    name: "Indicadores",
                    data: array.map((item) => ({ y: 5, color: item.color })),
                    zIndex: 4,
                    clip: false,
                    pointPlacement: "on",
                    marker: {
                        symbol: "circle",
                        radius: 12,
                    },
                    enableMouseTracking: false,
                    showInLegend: false,
                },
            ],
            responsive: {
                rules: [
                    {
                        condition: {
                            maxWidth: 600,
                        },
                        chartOptions: {
                            pane: {
                                size: "60%",
                            },
                            xAxis: {
                                labels: {
                                    distance: 20,
                                    style: {
                                        fontSize: "10px",
                                        width: "70px",
                                    },
                                },
                            },
                        },
                    },
                ],
            },
        };
    }

    return (
        <div
            className="page-relatorio-individual container-relatorio downloads"
        >
            {showPopUp && <CardPopUp />}
            {isLoading && (
                <Loading message="Gerando relatório, aguarde um pouco" />
            )}

            {!!data && (
                <div className="main-relatorio conjunto" id="imprimir">
                    <img
                        className="logo-abrafati-print"
                        src={logoAbrafati}
                        alt="logo da ABRAFATI"
                    />

                    <h2 className="title">
                        Sistema de Avaliação da Sustentabilidade - ABRAFATI{" "}
                        <strong>
                            {
                                ciclysAkatu.find(
                                    (item) => item.quiz_id === cyrcleStorage,
                                )?.cycle
                            }
                        </strong>
                    </h2>

                    <p className="relatorio__description">
                        O resultado do Sistema de Avaliação da Sustentabilidade,
                        demonstrado a seguir, permitirá compreender o estágio de
                        maturidade da empresa e indicar as questões mais
                        importantes para a construção de uma jornada contínua e
                        a evolução do setor em termos de seu desenvolvimento de
                        programas, procedimentos e soluções voltados à
                        sustentabilidade.
                    </p>

                    <div
                        className={`relatorio__container-results conjunto ${showBenchmarkData ? "no-results" : "resultados"}`}
                    >
                        <div className="relatorio__box-description">
                            <h4>Resultado Geral da empresa: {`${nameUser}`}</h4>
                            <p>
                                Abaixo o resultado geral com avaliação do grau
                                de maturidade da empresa, segundo as práticas de
                                sustentabilidade e compromissos para o setor:
                            </p>
                            <br />
                        </div>

                        <CardRelatorio
                            key={data?.data.data.stage.id}
                            percent={Math.round(data?.data.data.percent)}
                            average={data?.data.data.average}
                            estagio={data?.data.data.stage.name}
                            description={data?.data.data.stage.description}
                            descriptionStage={data?.data.data.stage.title}
                            score={Math.round(data?.data.data.score)}
                            percent_attendance={
                                data?.data.data.percent_attendance
                            }
                            banchmark={data?.data.data.banchmark}
                            banchmark_percent_attendance={
                                data?.data.data.banchmark_percent_attendance
                            }
                            sector={data?.data.data.sector}
                            total_score={data?.data.data.total_score}
                            showSectorData={showSectorData}
                            showBenchmarkData={showBenchmarkData}
                            idColor={`color-${data?.data.data.stage.id}`}
                            bgColor={`bg-${data?.data.data.stage.id}`}
                        />
                    </div>

                    <div className="box-relatorio-subtema conjunto">
                        <h4>Resultado por Subtema</h4>
                        <p>
                            Abaixo o resultado de avaliação por subtema,
                            representando as práticas empresariais de
                            sustentabilidade estabelecidas em medida de escala e
                            o comparativo com resultado benchmark do setor:
                        </p>
                    </div>

                    <div
                        className={`mandala-section conjunto ${
                            cyrcleStorage === 3 ? "center-graph" : ""
                        } ${
                            showBenchmarkInMandala
                                ? "resultados"
                                : "no-all-completed"
                        } ${
                            data?.data.data.subthemes?.length === 17
                                ? "layout-fabricante"
                                : ""
                        }`}
                    >
                        <div className="mandala-wrapper">
                            <img
                                src={companyRoleId === 2 ? imgGraph2 : imgGraph}
                                className="mandala-bg"
                                alt="Fundo da Mandala"
                            />
                            <div className="mandala-chart">
                                <HighchartsReact
                                    containerProps={{
                                        style: {
                                            width: "100%",
                                            height: "100%",
                                        },
                                    }}
                                    highcharts={Highcharts}
                                    options={options}
                                />
                            </div>
                        </div>
                    </div>

                    {showBenchmarkInMandala && (
                        <div className="legenda-benchmark">
                            <span className="legenda-benchmark__title">
                                Legenda:
                            </span>
                            <svg
                                width="45"
                                height="2"
                                className="legenda-benchmark__line"
                            >
                                <line
                                    x1="0"
                                    y1="1"
                                    x2="45"
                                    y2="1"
                                    stroke="#707070"
                                    strokeWidth="2"
                                    strokeDasharray="4, 3"
                                />
                            </svg>
                            <span className="legenda-benchmark__text">
                                Resultado benchmark
                            </span>
                        </div>
                    )}

                    <div className="box-relatorio-congratulations conjunto downloads">
                        <h4>Agradecemos a sua participação!</h4>
                        <p>
                            Continue evoluindo na promoção dos temas voltados à
                            sustentabilidade. Contribua com sua experiência e
                            participe de forma ativa na construção de soluções
                            para o setor de tintas e vernizes.
                        </p>
                    </div>

                    <div className="relatorio__box-btns no-print">
                        <span
                            onClick={() => window.print()}
                            className="btn-relatorio"
                        >
                            Imprimir
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Relatorio;

